import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from "lucide-react";
import PrivacyPolicy from "./legal/PrivacyPolicy";
import TermsOfService from "./legal/TermsOfService";

const Footer = () => {
  return (
    <footer className="relative text-white" style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)', transform: 'translateZ(0)', willChange: 'transform' }}>
      {/* Main content container */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 text-center md:text-left font-['Raleway'] font-semibold">
          {/* Company Info */}
          <div className="flex flex-col items-center md:items-start">
            <div className="flex justify-center -mt-10">
              <img 
                src="/renglans2.webp" 
                alt="RenGlans Logo" 
                className="h-32 w-auto"
              />
            </div>
            <p className="text-white/80 mb-6 text-base text-center md:text-left">
              Sveriges pålitliga städpartner sedan 1995. Prisbelönt service för hem och företag med miljövänliga produkter.
            </p>
            <div className="flex space-x-4 justify-center md:justify-start">
              <a href="#facebook" className="hover:text-red-500 transition-colors duration-300">
                <Facebook className="w-6 h-6 mx-1" />
              </a>
              <a href="#twitter" className="hover:text-red-500 transition-colors duration-300">
                <Twitter className="w-6 h-6 mx-1" />
              </a>
              <a href="#instagram" className="hover:text-red-500 transition-colors duration-300">
                <Instagram className="w-6 h-6 mx-1" />
              </a>
              <a href="#linkedin" className="hover:text-red-500 transition-colors duration-300">
                <Linkedin className="w-6 h-6 mx-1" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">Snabblänkar</h3>
            <ul className="space-y-3">
              <li><a href="/" className="text-white/80 hover:text-red-500 transition-colors duration-300 text-lg">Hem</a></li>
              <li><a href="/om-oss" className="text-white/80 hover:text-red-500 transition-colors duration-300 text-lg">Om Oss</a></li>
              <li><a href="/#tjanster" className="text-white/80 hover:text-red-500 transition-colors duration-300 text-lg">Tjänster</a></li>
              <li><a href="/galleri" className="text-white/80 hover:text-red-500 transition-colors duration-300 text-lg">Galleri</a></li>
              <li><a href="/#" className="text-white/80 hover:text-red-500 transition-colors duration-300 text-lg">Gratis Offert</a></li>
            </ul>
          </div>

          {/* For Customers */}
          <div>
            <h3 className="text-xl font-bold mb-6 text-white">För Kunder</h3>
            <ul className="space-y-3">
              <li><a href="#home-cleaning" className="text-white/80 hover:text-red-500 transition-colors duration-300 text-lg">Hemstädning</a></li>
              <li><a href="#office-cleaning" className="text-white/80 hover:text-red-500 transition-colors duration-300 text-lg">Kontorsstädning</a></li>
              <li><a href="#moving-cleaning" className="text-white/80 hover:text-red-500 transition-colors duration-300 text-lg">Flyttstädning</a></li>
              <li><a href="#rut" className="text-white/80 hover:text-red-500 transition-colors duration-300 text-lg">RUT-avdrag</a></li>
              <li><a href="#faq" className="text-white/80 hover:text-red-500 transition-colors duration-300 text-lg">Vanliga Frågor</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col items-center">
            <h3 className="text-xl font-bold mb-6 text-white text-center">Kontakta Oss</h3>
            <ul className="space-y-4 w-full px-4">
              <li className="flex flex-col items-center">
                <div className="flex flex-col items-center text-center">
                  <div className="flex items-center gap-3 mb-1">
                    <MapPin className="w-6 h-6 text-red-500 flex-shrink-0" />
                  </div>
                  <span className="text-white/80 text-lg">Drottninggatan 45<br />111 21 Stockholm</span>
                </div>
              </li>
              <li className="flex flex-col items-center">
                <div className="flex flex-col items-center">
                  <div className="flex items-center gap-3 mb-1">
                    <Phone className="w-6 h-6 text-red-500 flex-shrink-0" />
                  </div>
                  <a href="tel:0101234567" className="text-white/80 hover:text-red-500 transition-colors duration-300 text-lg">
                    010-123 45 67
                  </a>
                </div>
              </li>
              <li className="flex flex-col items-center">
                <div className="flex flex-col items-center">
                  <div className="flex items-center gap-3 mb-1">
                    <Mail className="w-6 h-6 text-red-500 flex-shrink-0" />
                  </div>
                  <a href="mailto:info@renglans.se" className="text-white/80 hover:text-red-500 transition-colors duration-300 text-lg">
                    info@renglans.se
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 text-center text-white/70">
          <p className="text-lg">&copy; {new Date().getFullYear()} RenGlans Städtjänster AB. Alla rättigheter förbehållna. 
            <span className="mx-2">•</span>
            <PrivacyPolicy /> 
            <span className="mx-2">•</span>
            <TermsOfService />
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
